import { __spreadArrays } from "tslib";
import { convertStylesToVariant } from './fonts';
var customFontConfig = {
    UnifySans: {
        regular: 'unify-sans-regular.css',
        italic: 'unify-sans-italic.css',
        '500': 'unify-sans-semibold.css',
        '500italic': 'unify-sans-semibold-italic.css',
        '700': 'unify-sans-bold.css',
        '700italic': 'unify-sans-bold-italic.css',
    },
    UnifySerif: {
        regular: 'unify-serif-regular.css',
        italic: 'unify-serif-italic.css',
        '500': 'unify-serif-semibold.css',
        '500italic': 'unify-serif-semibold-italic.css',
        '700': 'unify-serif-bold.css',
        '700italic': 'unify-serif-bold-italic.css',
    },
};
export var getCustomFontUrls = function (family, variants, baseUrl) {
    if (baseUrl === void 0) { baseUrl = 'https://www.gannett-cdn.com/gps/applications/adapt/fonts/'; }
    var fam = customFontConfig[family];
    return fam ? variants.map(function (v) { return baseUrl + fam[v]; }) : [];
};
/**
 * Adds a custom font the `custom` block of a WebFont config.
 */
export var addCustomFont = function (config, textBlock, allTextBlocks) {
    if (config === void 0) { config = {
        families: [],
    }; }
    var _a;
    var found = config.families.indexOf(textBlock.fontFamily) !== -1;
    var families = found
        ? config.families
        : __spreadArrays(config.families, [textBlock.fontFamily]);
    // get custom font urls based on predefined config
    var urls = (_a = families) === null || _a === void 0 ? void 0 : _a.reduce(function (carrier, fam) {
        // gather all variants for the current family
        // based on customFontConfig above
        // This does not take into account nested inner html (hi <i>friend</i>) as Google (which has flexible API)
        var variants = allTextBlocks
            .filter(function (t) { return t.fontFamily === fam; })
            .map(function (t) { return convertStylesToVariant(t.fontWeight, t.fontStyle); });
        return __spreadArrays(carrier, getCustomFontUrls(fam, variants));
    }, []);
    return {
        families: families,
        urls: urls,
    };
};
